import { postApi } from '../api/digitalVault';
import { parseRepositoryPaths } from '../utils';
export default async (id, props, logger) => {
    const data = new URLSearchParams();
    Object.entries(props).forEach(([key, arr]) => {
        arr.forEach((value) => data.append(key, value));
    });
    const { repositoryPaths } = await postApi(data, `playlist/${id}/paths`, {}, logger);
    return parseRepositoryPaths(repositoryPaths.repositoryPath);
};
